import { AfterViewInit, Component, Inject, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { StocksDeactivatingDataComponent } from '~/shared/components/deactivate-data/deactivate-data';
import { UsersService } from '~/services/administration.ts/users';
import { LocationsService } from '~/services/modules/stocks/locations';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';

@Component({
    selector: 'app-assigned-assets-popup',
    templateUrl: './assigned-assets-popup.component.html',
    styleUrls: ['./assigned-assets-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssignedAssetsPopupComponent implements OnInit,AfterViewInit {
  _active: boolean = true;
  _theme: string;
  _statuses = [{"text":"Yes", "value": true}, {"text":"No", "value": false}]
  _reasons = ["No longer with the Company", "Access Disabled", "Removed"]
  _locations: any[];
  _users: any[];
  loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";

  _itemId: any;
  _pageName: string = '';
  _batch: any;

  @ViewChild("deactivateConfirm") deactivateConfirm: ComboBoxComponent;
  @ViewChild("locationConfirm") locationConfirm: ComboBoxComponent;
  @ViewChild("personConfirm") personConfirm: ComboBoxComponent;
  @ViewChild("custodyConfirm") custodyConfirm: ComboBoxComponent;
  @ViewChild("checkoutConfirm") checkoutConfirm: ComboBoxComponent;

  @ViewChild("deactivateReason") deactivateReason: ComboBoxComponent;
  @ViewChild("deactivateLocation") deactivateLocation: ComboBoxComponent;
  @ViewChild("deactivatePerson") deactivatePerson: ComboBoxComponent;

  constructor(
    private _themeManager: ThemeManagerService,
    private _layoutComponent: LayoutComponent,
    private _sharedService: SharedService,
    private _locationsService: LocationsService,
    private _usersService: UsersService,
    @Inject(PORTAL_DATA) public data: any
  ) {
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._loadLocations();
    this._loadUsers();
    if (data) {
      if (data.model.itemId)
        this._itemId = data.model.itemId;
      else (data.model.batch)
        this._batch = data.model.batch;
      this._pageName = data.model.pageName;
  }
  }

  _loadLocations() {
    this._locationsService.getLocationListingBySite(JSON.parse(this.loggedInAccountSites)[0].siteId)
    .subscribe(result => {
      this._locations = result;
    })
  }

  _loadUsers() {
    this._usersService.getPersons()
    .subscribe(result => {
      this._users = result;
    })
  }

  ngAfterViewInit(): void {
    this.deactivateConfirm.toggle();
    this.deactivateConfirm.valueChange.subscribe(x => {
      if (x?.value === true) {
        setTimeout(() => {
          this.deactivateReason.toggle();
          this.deactivateReason.valueChange.subscribe(x => {
            if (x != null) {
              this.locationConfirm.toggle();
            }
          })
        });
      }
      else if (x?.value === false) {
        this.locationConfirm.toggle();
      }
    });
    this.locationConfirm.valueChange.subscribe(x => {
      if (x?.value === true) {
        setTimeout(() => {
          this.deactivateLocation.toggle();
          this.deactivateLocation.valueChange.subscribe(x => {
            if (x != null) {
              this.personConfirm.toggle();
            }
          })
        });
      }
      else if (x?.value === false) {
        this.personConfirm.toggle();
      }
    });
    this.personConfirm.valueChange.subscribe(x => {
      if (x?.value === true) {
        setTimeout(() => {
          this.deactivatePerson.toggle();
          this.deactivatePerson.valueChange.subscribe(x => {
            if (x != null) {
              this.custodyConfirm.toggle();
            }
          })
        });
      }
      else if (x?.value === false) {
        this.custodyConfirm.toggle();
      }
    });
    this.custodyConfirm.valueChange.subscribe(x => {
      if (x?.value != null) {
        this.checkoutConfirm.toggle();
      }
    });
  }

  ngOnInit(): void {
  }

  _closeForm() {
    this._active = false;
  }

  _onSave() {
    this._sharedService.okCloseClicked.subscribe((data:boolean) => {
      if (data) {
        this._layoutComponent.openDialogForm(StocksDeactivatingDataComponent, PageState.VIEW, { itemId: this._itemId, batch: this._batch, pageName: this._pageName});
        this._closeForm();
      }
    });

    this._closeForm();

    this._layoutComponent.openPopup({
        title: 'Notification',
        message: 'Are you sure you want to proceed with the changes?'
    });
  }
}
